import { request } from '@blade/common';
/**
 *@Description: 告警叠层详情
 */
export const alarmStackDetails = (data) => request({
    url: '/api/incident-record-management/api/v1/incident/records/queryRecord',
    method: 'POST',
    data,
});
